export default [
    {
        field: 'uf',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'UF ($)',
            // mask: '$ ##.###,##',
        },
        format: 'numeric',
        rules: [ 'required', 'numeric' ],
    },
    {
        field: 'utm',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'UTM ($)',
            // mask: '$ ##.###,##',
        },
        format: 'currency',
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'uta',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'UTA ($)',
            // mask: '$ ###.###,##',
        },
        format: 'currency',
        rules: [ 'required', 'isNotNegative' ],
    },
]
